import axios from 'axios';
import { defineAsyncComponent, markRaw } from 'vue';

// The Monumenti catalogue shows the archaeological area beside its cards. The geometries come from the Omnia
// spatial endpoint (public pages are merged by the shared public map pagination); the shared catalogue page only
// consumes this adapter and stays unaware of the tenant.
const OmniaCatalogMap = markRaw(defineAsyncComponent(() => import('../Components/Map/OmniaCatalogMap.vue')));

const feature = Object.freeze({
    supports: sheet => sheet?.name === 'omnia_monument',
    label: 'Area archeologica',
    showTitle: 'Mostra mappa',
    hideTitle: 'Nascondi mappa',
    component: OmniaCatalogMap,
    async load({ signal }) {
        const { data } = await axios.get('/omnia/spatial/map', { signal });
        const layers = data?.layers ?? {};
        return {
            records: Array.isArray(data?.monuments) ? data.monuments : [],
            props: { token: layers.omniaMapToken ?? '', layers: layers.omniaMapLayers ?? null, view: layers.omniaMapView ?? null },
        };
    },
    recordId: record => record?.record_id ?? record?.id,
    recordSheet: record => record?.record_sheet ?? 'omnia_monument',
});

export const resolveCatalogMapFeature = (theme = 'Default') => theme === 'Omnia' ? feature : null;
